import React from "react";
import Scroll from "react-scroll-to-element";
import { SocialMenu } from "./SocialMenu";
import { Copyright } from "./Copyright";
export class Studio extends React.Component {

 
  render() {
    let photoGallery = this.props.studio.gallery;
    let regex = /"htt(.*?)"/gm;
    let match = photoGallery.match(regex);
    let singleImg = match.map((src, index) => {
      let newSrc = src.slice(1).slice(0, -1);
      return <img key={index} src={newSrc} alt={`studio-${index}`} />;
    });
    return (
   
     
         <div className="studio-wrap">
        <SocialMenu />
        <Copyright />
        <div
          className="studio-description"
          dangerouslySetInnerHTML={{ __html: this.props.studio.description }}
        />
        <div className="studio-gear">
          <div className="studio-gear-label">Sprzęt:</div>
          <div
            className="studio-gear-list-wrap"
            dangerouslySetInnerHTML={{ __html: this.props.studio.gear }}
          />
          <Scroll
            type="class"
            element="studio-price-list"
            offset={window.innerWidth > 559 ? -312 : -100}
          >
            <button className="studio-button">cennik</button>
          </Scroll>
        </div>
        <div className={`studio-image-wrap-1`}>{singleImg[0]}</div>
        <div className={`studio-image-wrap-2`}>{singleImg[1]}</div>
        {!this.props.isMobile && (
          <div className="studio-price-list">
            <div className="studio-price-list-label">Cennik:</div>
            <div
              className="studio-price-list-wrap"
              dangerouslySetInnerHTML={{
                __html: this.props.studio.price_list
              }}
            />
          </div>
        )}
        <div className={`studio-image-wrap-3`}>
          {this.props.isMobile && (
            <div className="studio-price-list">
              <div className="studio-price-list-label">Cennik:</div>
              <div
                className="studio-price-list-wrap"
                dangerouslySetInnerHTML={{
                  __html: this.props.studio.price_list
                }}
              />
            </div>
          )}
          {singleImg[2]}
        </div>
        <div className={`studio-image-wrap-4`}>{singleImg[3]}</div>
        <div className={`studio-image-wrap-5`}> {singleImg[4]}</div>
        <div className={`studio-image-wrap-6`}> {singleImg[5]}</div>
      </div>
      
   
     
    );
  }
}



// WEBPACK FOOTER //
// ./src/Studio.js